import { logger } from '@modules/logger';
import { type ReactNode, createContext } from 'react';

type TourStep = {
  id: string;
  active: boolean;
  completed: boolean;
  content: ReactNode;
} & (
  | {
      target: string;
      type: 'tooltip';
      content: ReactNode;
      title?: string;
      allowClicks?: boolean;
      hideFooter?: boolean;
      hideBackButton?: boolean;
      hideCloseButton?: boolean;
    }
  | {
      type: 'dialog';
      ariaLabel: string;
    }
);

type TourAction =
  | { type: 'START' }
  | { type: 'FINISH' }
  | { type: 'INITIALIZE_TOUR'; value: TourStep[] }
  | { type: 'GO_TO_NEXT_STEP' }
  | { type: 'GO_TO_PREV_STEP' }
  | { type: 'COMPLETE_CURRENT_STEP' }
  | { type: 'MAKE_STEP_ACTIVE'; value: string; completePreviousSteps?: boolean };
//| { type: "ACTIVATE_STEP"; value: string };

interface TourContextValues {
  tourState: 'off' | 'show' | 'finish';
  tourSteps: TourStep[];
  dispatch: (action: TourAction) => void;
}

const TourContext = createContext<TourContextValues>({
  tourState: 'off',
  tourSteps: [],
  dispatch: () => logger.warn('dispatch not provided for TourContext'),
});

export { TourContext };
export type { TourStep, TourAction };
